import React from "react";
import { NextSeo } from "next-seo";

const DmcaPolicyPage = () => {
  return (
    <div className="container">
      <NextSeo
        title="DMCA & Copyright Policy | Jammable"
        description="Jammable's DMCA and copyright policy. Learn how to report copyright infringement and trademark violations."
        canonical="https://www.jammable.com/dmca-policy"
      />
      <div className="main">
        <div className="title">DMCA & Copyright</div>
        Jammable acts in accordance with the Digital Millennium Copyright Act of
        1998, If you own a copyright or have authority to act on behalf of a
        copyright owner and want to report a claim that a third party is
        infringing that material on or through Jammable&apos;s services, please
        send a notice that meets the minimum requirements of the DMCA, to
        dmca@jammable.com, and we will take appropriate action.
        <div className="subtitle">DMCA Notice Requirements</div>
        You must include:
        <ol>
          <li>
            Identification of the copyrighted work or works claimed to have been
            infringed.
          </li>
          <li>
            A description of the material you claim is infringing and that you
            want removed or access to which you want disabled and the URL or
            other location of that material;
          </li>
          <li>
            Your name, title (if acting as an agent), address, telephone number,
            and email address;
          </li>
          <li>
            The following statement: “I have a good faith belief that the use of
            the copyrighted material I am complaining of is not authorized by
            the copyright owner, its agent, or the law (e.g., as a fair use)”;
          </li>
          <li>
            The following statement: “The information in this notice is accurate
            and, under penalty of perjury, I am the owner, or authorized to act
            on behalf of the owner, of the copyright or of an exclusive right
            that is allegedly infringed”; and
          </li>
          <li>
            An electronic or physical signature of the owner of the copyright or
            a person authorized to act on the owner’s behalf.
          </li>
        </ol>
        Submissions under this DMCA Policy should be sent to dmca@jammable.com
        We will review your submission and take whatever action we deem
        appropriate under the DMCA, including the removal of the challenged
        content from the website. Further more, we may, in appropriate
        circumstances, disable access or terminate the account(s) of the
        reported user(s).
        <n />
        <div className="subtitle">Trademark takedown request requirements</div>
        <div>
          If you’re sure you want to report content on Jammable that you believe
          infringes your trademark, please provide the following information:
        </div>
        <ol>
          <li>
            Details of the original trademark (and a description if it’s a
            logo).
          </li>
          <li>A list of the countries in which the trademark is registered.</li>
          <li>The registration number(s) of the trademark.</li>
          <li>
            A scanned copy of the trademark registration certificate(s) or
            screenshot of the registration on the website or database of the
            applicable national intellectual property office(s).
          </li>
          <li>
            A declaration of the following statement: “By submitting this
            notice, I state that I have a good-faith belief that the reported
            use, in the manner that I have complained of, is not authorized by
            the intellectual property rights owner, its agent or the law; that
            the information contained in this notice is accurate; and, under
            penalty of perjury, that I am authorized to act on behalf of the
            owner of the intellectual property rights at issue”.
          </li>
        </ol>
        <div>You can send this information to dmca@jammable.com.</div>
        <div className="subtitle">Repeat Infringer Policy</div>
        Repeat Infringer Policy We will suspend or terminate accounts if the
        user is determined to be a “repeat infringer”. In appropriate cases and
        at our sole discretion we may limit access to the Jammable service
        and/or terminate accounts of users who blatantly infringe the
        intellectual property rights of others whether or not repeat
        infringement has occurred. This could for example happen if a relevant
        court rules that the account holder is a infringer.
        <div className="subtitle">Designated Agent</div>
        <div>
          Our agent to receive such notifications of claimed infringement is
          Aditya Bansal. Email: dmca@jammable.com Mailing Address: 119
          Marylebone Road London, NW1 5PU
        </div>
      </div>
    </div>
  );
};

export default DmcaPolicyPage;
